<template lang="pug">
keep-alive
  .res
    .title {{$t('reservation.res2.title')}}
    .content
      ticket-picker
    //- .bottom
    //-   primary-btn(type="nextStep" @clicked="onNext" :active="ticketPicked")
      //.btn-next(@click="onNext" :active="ticketPicked") {{$t('btn.nextStep')}}
    charity-popup(v-if="showCharityPopup")


  
</template>
<script>
import FamPicker from '@/components/res/FamPicker'
import { mapState, mapMutations } from 'vuex'
import TicketPicker from '@/components/res/TicketPicker'
import PrimaryBtn from '@/components/wedgits/PrimaryBtn'
import CharityPopup from '@/components/wedgits/CharityPopup'
export default {
  name: 'Res2',
  components: { CharityPopup, PrimaryBtn, TicketPicker },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['ticketPicked', 'showCharityPopup']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setRouterLast']),
    onNext() {
      this.setRouterBack('/reservation/res2')
      this.$router.replace('/reservation/res3')
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
@import "src/styles/res.sass"
.res
</style>
